const aws_region = "us-east-1";

const config = {
  appName: "Trust UI - Sandbox",
  region: aws_region,
  cognito: {
    userPoolId: `${aws_region}_QWSU8Cw43`,
    domain: `ispp-trust-co-token-dev.auth.${aws_region}.amazoncognito.com`,
    tokenUrl: `https://ispp-trust-co-token-dev.auth.${aws_region}.amazoncognito.com/oauth2/authorize`,
    providerId: "ispp-trust-co-identity-provider",
    redirectUrl: "https://citplanmanager.am.dev.principal.com",
    clientId: "6emv04qg9g9n4rk4m4hjn13s2",
    scope: "ispp-trust-co-resource-server/read-write",
    readOnlyGroup: "trust-co-read-only-client",
    updateGroup: "ispp-trust-co-read-write-client",
  },
  api: {
    baseUrl: `https://03f4s90l7g.execute-api.${aws_region}.amazonaws.com/prod/api`,
  },
};

export default config;
